module.exports = __webpack_public_path__ + "img/male8.fcc18a2e.jpeg";